export const IAS_MULTIPLIER_B5 = 0.7;

export const maxMonthsMceContractDuration = 36;
